'use client';

import { queryOptions, useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { plansOptions } from '../queries/plans';
import { PdpInfoDTO, PlanFilter } from '@/types/models';
export function usePlans(filter: PlanFilter): UseSuspenseQueryResult<PdpInfoDTO[]> {
  return useSuspenseQuery(queryOptions(plansOptions(filter)));
}